import { debounce } from "lodash-es"
import { exoClickBottomPc } from "./templates"
import "./exoclick-style.css"
import { isMobile } from "@modules/util/device"

export const exoClickOnWindowResizeDebounceMs = 200

export function rerenderExoClickPcBottom() {
    if (userData.hasAdFree || !userData.isAgeVerified) {
        return
    }

    const pcExoClick = document.querySelector("#exoclick-bottom")
    if (pcExoClick) {
        pcExoClick.outerHTML = exoClickBottomPc
    }
}

if (!userData.hasAdFree && userData.isAgeVerified) {
    window.addEventListener("orientationchange", debounce(rerenderExoClickPcBottom, exoClickOnWindowResizeDebounceMs))
    // DONT initiate an event listener on resize to rerender solads or exoclick on mobile
    // It will trigger on mobile when scrolling and the browser bar shows/hides. Which triggers a lot of rerenders while scrolling
    // alternative fix would be to check for width changes only.
    if (!isMobile()) {
        window.addEventListener("resize", debounce(rerenderExoClickPcBottom, exoClickOnWindowResizeDebounceMs))
    }
}
